export const isProduction = process.env.NODE_ENV === 'production';
//todo: separate NODE_ENV into EXEC_ENV and ENV_MODE
//ENV_MODE - environment mode - dev|stage|prod
//EXEC_ENV - actual execution environment - local|k8s|node??
